/**
 * Regex pattern for splitting on whitespace.
 * Pre-compiled for performance.
 */
const WHITESPACE_REGEX = /\s+/;

/**
 * Expands camelCase text into space-separated words.
 * Example: "getUserData" -> "get user data"
 */
export function expandCamelCase(text: string): string {
  return text.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
}

/**
 * Extracts search terms from a value, splitting on whitespace.
 * Returns lowercase terms for case-insensitive matching.
 */
export function getSearchTerms(value: unknown): string[] {
  return typeof value === "string"
    ? value.toLowerCase().split(WHITESPACE_REGEX).filter(Boolean)
    : [];
}

/**
 * Checks if all search terms are found within the provided texts.
 * Each term must be included in at least one of the texts.
 */
export function includesAll(texts: string[], terms: string[]): boolean {
  if (terms.length === 0) {
    return true;
  }
  return terms.every((term) => texts.some((t) => t.includes(term)));
}

/**
 * Checks if a tool name and toolkit name match the given search terms.
 * Supports camelCase expansion for better matching.
 */
export function matchesSearch(
  name: string,
  toolkitName: string,
  searchTerms: string[]
): boolean {
  return includesAll(
    [
      name.toLowerCase(),
      expandCamelCase(name),
      toolkitName.toLowerCase(),
      expandCamelCase(toolkitName),
    ],
    searchTerms
  );
}
